import AuthService from "../../AuthService";
const menu = {
  getMenu(page) {
    return AuthService.get("/menu/menus?page=" + page);
  },
  showMenu(id) {
    return AuthService.get("/menu/menus/" + id);
  },
  createMenu(data) {
    return AuthService.post("/menu/menus", data);
  },
  updateMenu(id, data) {
    return AuthService.put("/menu/menus/" + id, data);
  },
  deleteMenu(id) {
    return AuthService.delete("/menu/menus/" + id);
  },
  getAllMenu() {
    return AuthService.get("/menu/get_menu_all");
  }
};
export default menu;
